import type { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

/**
 * @deprecated This container is no longer needed as ChatTabsContext is provided by Chat.State.
 * This component now just passes through children for backwards compatibility.
 * Consider removing this wrapper and using children directly.
 */
export const ChatTabsContainer: FC<Props> = ({ children }) => {
  return <>{children}</>;
};

ChatTabsContainer.displayName = 'Chat.Tabs.Container';